import React from "react";

const LicenseExpiredModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center  bg-opacity-60 backdrop-blur-sm">
      <div className="bg-white rounded-3xl shadow-2xl p-8 w-[90%] t:max-w-lg text-center animate-fadeIn">
        <h2 className="text-3xl font-semibold text-red-600 mb-4">
          License Expired
        </h2>
        <p className="text-gray-800 mb-6 leading-relaxed">
          Your license has expired. Please contact{" "}
          <span className="font-medium">support@geniusoffice.com</span> or call
          us at <span className="font-medium">+91 85589 51962</span> for
          renewal.
          <br />
          Visit{" "}
          <a
            href="https://www.geniusoffice.com"
            className="text-blue-600 underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.geniusoffice.com
          </a>
        </p>
        <button
          onClick={onClose}
          className="mt-2 bg-red-400 w-full hover:bg-red-700 text-white px-6 py-2 rounded-lg transition font-semibold"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default LicenseExpiredModal;
